<template>
  <div class="details">
    <div
      class="details-left"
      id="selector"
      :class="{active: curr==='列表'}"
      @click="switchPage('列表')"
    >
      <ul class="nav nav-tabs-ul" role="tablist" :style="btnFlag?'top:60px;':'top: 150px;'">
        <li v-if="categoryList.length > 0">
          <a :class="{active:!btnFlag}" href="#base">基本信息</a>
        </li>
        <li v-for="item in categoryList" :key="item.id">
          <a :class="{active:show===item.name}" :href="'#'+item.name">{{item.name}}</a>
        </li>
      </ul>
    </div>
    <div class="details-right" data-spy="scroll" data-target="#selector" style="padding-bottom: 60px">
      <img v-if="btnFlag" class="go-top" src="../../assets/images/top.png" @click="backTop" />
      <div class="box-container">
        <a id="base" style="position: relative;top: -80px;"></a>
        <div class="details-head">基本信息</div>
        <div class="details-button">
          <span class="button-click disabled">在线办理</span>
          <span class="button-click disabled">指南下载</span>
          <span class="button-click disabled">在线预约</span>
          <span class="button-click disabled">
            <i class="fa fa-heart"></i>收藏
          </span>
          <span class="button-click disabled">在线评价</span>
          <span
            class="button-click disabled"
            style="cursor: pointer"
            :class="{active: curr==='服务能力'}"
            @click="switchPage('服务能力')"
          >服务能力</span>
        </div>
        <div class="details-form">
          <table class="table-bordered">
            <tr>
              <th>名称</th>
              <td>{{msgData.name}}</td>
              <th>联系方式</th>
              <td>{{msgData.phone}}</td>
            </tr>
            <tr>
              <th>网址</th>
              <td>
                <a target="_blank" :href="msgData.webUrl">{{msgData.webUrl}}</a>
              </td>
              <th>部门等级</th>
              <td>{{msgData.level}}</td>
            </tr>
            <tr>
              <th>省份</th>
              <td>{{msgData.provinceCode}}</td>
              <th>邮编</th>
              <td>{{msgData.email}}</td>
            </tr>
            <tr>
              <th>地址</th>
              <td colspan="3">{{msgData.address}}</td>
            </tr>
          </table>
        </div>
      </div>
      <div class="service-category" v-if="curr=='服务能力'">
        <div class="details-head">服务能力</div>
        <table class="service">
          <tr>
            <th>被测（参量/仪器/物质）</th>
            <th>校准类别/校准参量</th>
            <th>测量仪器型号/校准方法</th>
            <th>扩展不确定度</th>
            <th>测量环境/影响量</th>
            <th>测量等级</th>
          </tr>
          <tr v-for="item in normalListData" :key="item.id">
            <td v-if="item.measureObject&&item.organName!=='null'">{{item.measureObject}}</td>
            <td v-if="item.calibrationType&&item.calibrationType!=='null'">{{item.calibrationType}}</td>
            <td v-if="item.calibrationType&&item.calibrationType!=='null'">{{item.measureModel }}</td>
            <td>
              <div
                v-if="item.expandedUncertaintyValue&&item.expandedUncertaintyValue!=='null'"
              >数值:{{item.expandedUncertaintyValue}}</div>
              <div
                v-if="item.expandedUncertaintyUnit&&item.expandedUncertaintyUnit!=='null'"
              >单位:{{item.expandedUncertaintyUnit}}</div>
              <div
                v-if="item.expandedUncertaintyK&&item.expandedUncertaintyK!=='null'"
              >k:{{item.expandedUncertaintyK}}</div>
              <div
                v-if="item.expandedUncertaintyProbability&&item.expandedUncertaintyProbability!=='null'"
              >置信概率:{{item.expandedUncertaintyProbability}}</div>
              <div
                v-if="item.expandedUncertaintyIsurel&&item.expandedUncertaintyIsurel!=='null'"
              >是否为Urel:{{item.expandedUncertaintyIsurel}}</div>
            </td>
            <td>
              <div
                v-if="item.measureEnviromentParam&&item.measureEnviromentParam!=='null'"
              >参量:{{item.measureEnviromentParam}}</div>
              <div
                v-if="item.measureEnviromentIndex&&item.measureEnviromentIndex!=='null'"
              >指标:{{item.measureEnviromentIndex}}</div>
            </td>
            <td>
              <div
                v-if="item.measureLevelMin&&item.measureLevelMin!=='null'"
              >最小:{{item.measureLevelMin}}</div>
              <div
                v-if="item.measureLevelMax&&item.measureLevelMax!=='null'"
              >最大:{{item.measureLevelMax}}</div>
              <div
                v-if="item.measureLevelUnit&&item.measureLevelUnit!=='null'"
              >单位:{{item.measureLevelUnit}}</div>
            </td>
          </tr>
        </table>
        <pagination :page="page" @on-change="changePage"></pagination>
      </div>
      <div v-for="item in categoryList" :key="item.id" class="box-container" v-if="curr=='列表'">
        <a :id="item.name" style="position: relative;top: -80px;"></a>
        <div class="details-head">{{item.name}}</div>
        <div class="details-words" v-for="element in item.calOrgServiceList" :key="element.id">
          <span class="words-url">
            <a to="/test2" target="_blank" :href="element.webUrl">{{element.name}}</a>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from '@/components/pagination';
export default {
  name: 'metroloyDetail',
  components: {
    Pagination
  },
  data () {
    return {
      curr: '列表',
      page: {
        currPage: 1,
        pageSize: 10
      },
      btnFlag: '',
      msgData: '',
      categoryList: [],
      calOrgServiceList: [],
      show: '',
      normalListData: []
    };
  },
  created () {
    window.scrollTo(0, 0);
  },
  computed: {
    detailId: function () {
      return window.localStorage.getItem('id');
    }
  },
  mounted () {
    window.addEventListener('scroll', this.scrollToTop);
    this.fetchList();
    $('body').scrollspy({ target: '#selector' });
  },
  destroyed () {
    window.removeEventListener('scroll', this.scrollToTop);
  },
  methods: {
    changePage (page) {
      this.page.currPage = page;
      this.getListData(this.detailId);
      // this.getAccountList();
    },
    switchPage (page) {
      this.curr = page;
    },
    getListData (id) {
      let url = '/cal/calTechnicalRelation/technicalCapacity/' + id;
      this.post(url, {
        query: this.listParams ? this.listParams : {},
        page: this.page
      }).then(res => {
        this.normalListData = [];
        this.normalListData = res.data.list;
        this.page = res.data.page;
      });
    },
    fetchList () {
      this.msgData = [];
      this.categoryList = [];
      let url = '/cal/calOrgan/info/' + this.detailId;
      this.verify('fetch', url, {}, res => {
        this.msgData = res.data;
        this.categoryList = res.data.categoryList;
        this.inintCalOrgServiceList();
        this.getListData(res.data.id);
      });
    },
    inintCalOrgServiceList () {
      this.getCalOrgServiceList(this.categoryList[0]);
    },
    getCalOrgServiceList (item) {
      this.calOrgServiceList = item.calOrgServiceList;
    },
    backTop () {
      const that = this;
      let timer = setInterval(() => {
        let ispeed = Math.floor(-that.scrollTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop =
          that.scrollTop + ispeed;
        if (that.scrollTop === 0) {
          clearInterval(timer);
        }
      }, 16);
    },
    scrollToTop () {
      const that = this;
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      that.scrollTop = scrollTop;
      if (that.scrollTop > 180) {
        that.btnFlag = true;
      } else {
        that.btnFlag = false;
      }
    }
  }
};
</script>

<style scoped lang="less">
.details {
  position: relative;
  width: 1160px;
  margin: 0 auto;
  .details-left {
    .nav-tabs-ul {
      width: 150px;
      left: 50%;
      position: fixed;
      margin-left: -725px;
      transition: all .3s;
    }
    .nav-tabs-ul li {
      width: 150px;
      font-size: 14px;
      height: 40px;
      text-align: right;
      line-height: 40px;
      cursor: pointer;
      &.active {
        font-size: 20px;
        font-weight: bold;
        a {
          color: @color-base;
        }
      }
      a.active {
        font-size: 20px;
        font-weight: bold;
        color: @color-base;
      }
    }
    .nav-tabs-ul li a {
      display: inline-block;
      width: 150px;
      vertical-align: middle;
      line-height: 22px;
      color: #666666;
    }
  }
  .details-right {
    position: relative;
    .box-container {
      box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.1);
      margin-top: 20px;
      padding: 0 20px 20px;
    }
    .actives {
      border-left: 4px solid @color-base;
    }
    .details-head {
      padding-left: 32px;
      line-height: 60px;
      background: rgba(200, 228, 255);
      font-size: 24px;
      font-weight: 600;
      color: rgba(0, 0, 0, 0.85);
      margin: 0 -20px;
      border-left: 4px solid @color-base;
      border-bottom: 1px solid rgba(@color-base, 0.2);
    }
    .details-button {
      line-height: 74px;
      .button-click {
        display: inline-block;
        background: rgba(0, 141, 255, 0.1);
        font-weight: 400;
        color: @color-base;
        cursor: pointer;
        width: 120px;
        height: 40px;
        text-align: center;
        line-height: 40px;
        font-size: 16px;
        .fa {
          margin-right: 6px;
        }
        &.disabled {
          background-color: #f8f8f8;
          color: #ccc;
          cursor: default;
        }
      }
    }
    .details-form {
      .table-bordered {
        width: 100%;
        a {
          color: @color-base;
        }
        tr {
          td {
            width: 280px;
            padding-left: 24px;
            border: 1px solid rgba(0, 0, 0, 0.1);
            line-height: 60px;
            font-size: 14px;
            font-weight: 400;
            color: rgba(0, 0, 0, 0.84);
          }
          th {
            padding-left: 24px;
            width: 180px;
            background: rgba(0, 0, 0, 0.05);
            border: 1px solid rgba(0, 0, 0, 0.1);
            line-height: 60px;
            font-size: 14px;
            font-weight: 600;
            color: #000;
          }
        }
      }
    }
    .details-word {
      padding: 30px 60px;
      span {
        display: block;
        font-size: 16px;
        font-weight: 400;
        color: #000;
        line-height: 32px;
      }
    }
    .go-top {
      cursor: pointer;
      position: fixed;
      right: 0;
      bottom: 120px;
    }
    .details-words:hover {
      cursor: pointer;
      box-shadow: 0 6px 10px 0 rgba(0, 141, 255, 0.1);
      border: 1px solid rgba(0, 141, 255, 0.1);
    }
    .details-words {
      margin: 20px 0 0 10px;
      width: 270px;
      line-height: 50px;
      background: rgba(0, 0, 0, 0.05);
      display: inline-block;
      text-align: center;
      border: 1px solid rgba(0, 0, 0, 0.05);
      /*.words-block {*/
      /*  font-size:18px;*/
      /*  font-weight:500;*/
      /*  color:rgba(0,0,0,1);*/
      /*}*/
      .words-url {
        a {
          font-size: 16px;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.65);
        }
      }
      span {
        font-size: 16px;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.84);
        line-height: 32px;
      }
      .word-time {
        float: right;
      }
    }
    .details-words:hover a {
      color: @color-base;
    }
    .frame-box {
    }
    .service-category {
      margin-top: 20px;
      .details-head {
        padding-left: 32px;
        line-height: 60px;
        font-size: 24px;
        font-weight: 600;
        color: rgba(0, 0, 0, 0.85);
        margin: 0 auto;
        border-left: 4px solid @color-base;
        border-bottom: 1px solid rgba(@color-base, 0.2);
      }
      table {
        border-collapse: collapse;
        margin: 0 auto;
        margin-top: 10px;
        text-align: center;
        width: 1160px;
      }
      table td,
      table th {
        border: 1px solid #cad9ea;
        color: #666;
        height: 30px;
        text-align: center;
        padding: 2px;
      }
      table thead th {
        background-color: #cce8eb;
        width: 80px;
      }
      table tr:nth-child(odd) {
        background: #fff;
      }
      table tr:nth-child(even) {
        background: #f5fafa;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/detail/metroloyDetail.vue